import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const ContactSettings        = () => import('@/views/contact/ContactSettings.vue');
const ContactSettingsData    = () => import('@/views/contact/settings/ContactSettingsData.vue');
const ContactRightSettings   = () => import('@/views/contact/settings/ContactRightSettings.vue');
const ContactingSettings     = () => import( '@/views/contact/settings/ContactContactingSettings.vue');
const ContactingTypeSettings = () => import( '@/views/contact/settings/ContactingTypeSettings.vue');
const ContactSettingsSearch  = () => import('@/views/contact/settings/ContactSettingsSearch.vue');

const ContactIndex                = () => import('@/views/contact/ContactIndex.vue');
const ContactResubmissionListView = () => import('@/views/contact/ContactResubmissionListView.vue');
const ContactEntryView            = () => import('@/views/contact/ContactEntryView.vue');
const ContactEntryEdit            = () => import('@/views/contact/ContactEntryEdit.vue');
const ContactContactingEdit       = () => import('@/views/contact/ContactContactingEdit.vue');
const ContactList                 = () => import('@/views/contact/ContactList.vue');
const ContactLastContacting       = () => import('@/views/contact/ContactLastContacting.vue');

let meta: MetaData = {
    module: 'contact',
};

let contact: RouteRecordRaw[] = [
    {
        name: 'contact-index',
        path: '/contact',
        component: ContactIndex,
        meta,
    },
    {
        name: 'contact-last-contacting',
        path: '/contact/last-contacting/:route(pms)?/:mine(mine)?',
        component: ContactLastContacting,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                route: route.params.route || 'contact',
                mine: !!route.params.mine,
            };
        },
    },
    {
        name: 'contact-resubmission-list',
        path: '/contact/resubmission/list/:id(\\d+)?',
        alias: '/contact/resubmission/list',
        component: ContactResubmissionListView,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id) || 0};
        },
        meta,
    },
    {
        name: 'contact-entry-view',
        path: '/contact/entry/view/id/:id(\\d+)',
        alias: '/contact/entry/view/:id(\\d+)',
        component: ContactEntryView,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id)};
        },
        meta,
    },
    {
        name: 'contact-entry-edit',
        path: '/contact/entry/edit/:id(\\d+)?',
        alias: '/contact/entry/edit/id/:id(\\d+)?',
        component: ContactEntryEdit,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id) || 0};
        },
        meta,
    },
    {
        name: 'contact-contacting-edit',
        path: '/contact/contacting/edit/institution/:institutionId(\\d+)',
        component: ContactContactingEdit,
        props(route: RouteLocationStringParam)
        {
            return {institutionId: parseInt(route.params.institutionId)};
        },
        meta,
    },
    {
        name: 'contact-list',
        path: '/contact/list',
        component: ContactList,
        meta,
    },
    {
        path: '/contact/:wildcard*',
        redirect: {name: 'contact-index'},
    },
    {
        path: '/contact/settings/:route(intranet)?',
        name: 'contact-settings',
        component: ContactSettings,
        meta,
        alias: [
            '/contact/settings/:route(intranet)?/:wildcard*',
        ],
        children: [
            {
                path: 'contact-data',
                name: 'contact-settings-contact-data',
                component: ContactSettingsData,
                meta,
            },
            {
                path: 'contacting',
                name: 'contact-settings-contacting',
                component: ContactingSettings,
                meta,
            },
            {
                path: 'contact-type',
                name: 'contact-settings-type',
                component: ContactingTypeSettings,
                meta,
            },
            {
                path: 'contact-rights',
                name: 'contact-settings-rights',
                meta,
                redirect: {
                    name: 'contact-settings-rights-settings',
                    params: {
                        type: 'contact-rights',
                        tab: 'add',
                    },
                },
                children:[
                    {
                        path: ':tab?',
                        name: 'contact-settings-rights-settings',
                        component: ContactRightSettings,
                        meta,
                    },
                ]
            },
            {
                path: 'search',
                name: 'contact-settings-search',
                component: ContactSettingsSearch,
                meta,
            },
        ],
    },
];

export default contact;